import { Label, Table } from "reactstrap";
import InvoiceFooter from "./InvoiceFooter";
import { InvoiceSixData, InvoiceSixTableData } from "../../../../../Data/Applications/ECommerce/ECommerce";
import { H6, P } from "../../../../../AbstractElements";
import { Total } from "../../../../../Constants/Constants";

const InvoiceSixTable = () => {
  return (
    <div>
      <div className="table-responsive invoice-table" id="table">
        <Table bordered striped>
          <tbody>
            <tr>
              {InvoiceSixTableData.map((data, i) => (
                <td className="item" key={i}><H6 className="p-2 mb-0">{data}</H6></td>
              ))}
            </tr>
            {InvoiceSixData.map((data, i) => (
              <tr key={i}>
                <td>
                  <Label>{data.title}</Label>
                  <P className="m-0">{data.detail}</P>
                </td>
                <td><P className="itemtext">{data.hours}</P></td>
                <td><P className="itemtext">${data.price}</P></td>
                <td><P className="itemtext">${data.total}.00</P></td>
              </tr>
            ))}
            <tr>
              <td><P className="itemtext" /></td>
              <td><P className="m-0">HST</P></td>
              <td><P className="m-0">13%</P></td>
              <td><P className="m-0">$419.25</P></td>
            </tr>
            <tr>
              <td /><td />
              <td className="Rate"><H6 className="mb-0 p-2">{Total}</H6></td>
              <td className="payment"><H6 className="mb-0 p-2">$3,644.25</H6></td>
            </tr>
          </tbody>
        </Table>
      </div>
      <InvoiceFooter />
    </div>
  );
};

export default InvoiceSixTable;
